import { render, staticRenderFns } from "./listings-header.vue?vue&type=template&id=32c48ca0"
import script from "./listings-header.vue?vue&type=script&lang=js"
export * from "./listings-header.vue?vue&type=script&lang=js"
import style0 from "./listings-header.vue?vue&type=style&index=0&id=32c48ca0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports